import { Venue } from "./venue.ts";
import { EventArtist } from "./eventArtist.ts";
import { EventInstructor } from "./eventInstructor.ts";

interface EventInterface {
    id: number | null;
    documentId: string | null;
    date: string | null;
    title: string | null;
    ticketUrl: string | null;
    instagramUrl: string | null;
    createdAt: string | null;
    updatedAt: string | null;
    publishedAt: string | null;
    source: string | null;
    lastSeen: string | null;
    venue: Venue | null;
    event_artists: EventArtist[];
    event_instructors: EventInstructor[];
}

class Event implements EventInterface {
    id: number | null;
    documentId: string | null;
    date: string | null;
    title: string | null;
    ticketUrl: string | null;
    instagramUrl: string | null;
    createdAt: string | null;
    updatedAt: string | null;
    publishedAt: string | null;
    source: string | null;
    lastSeen: string | null;
    venue: Venue | null;
    event_artists: EventArtist[];
    event_instructors: EventInstructor[];

    constructor(params: Partial<EventInterface> = {}) {
        this.venue = params.venue ?? null;
        this.date = params.date ?? null;
        this.event_artists = params.event_artists ?? [];
        this.event_instructors = params.event_instructors ?? [];
        this.id = params.id ?? null;
        this.documentId = params.documentId ?? null;
        this.title = params.title ?? null;
        this.ticketUrl = params.ticketUrl ?? null;
        this.instagramUrl = params.instagramUrl ?? null;
        this.createdAt = params.createdAt ?? null;
        this.updatedAt = params.updatedAt ?? null;
        this.publishedAt = params.publishedAt ?? null;
        this.source = params.source ?? null;
        this.lastSeen = params.lastSeen ?? null;
    }

    static fromStrapi(data: any): Event {
        // Assumes Strapi returns { data: { ...event fields... } }
        console.debug("DATA", data);
        const e = data.data || data;
        const venue = e.venue ? new Venue(e.venue) : null;

        const event_artists = Array.isArray(e.event_artists)
            ? e.event_artists.map(
                (ea: any) => new EventArtist(ea)
            )
            : [];

        const event_instructors = Array.isArray(e.event_instructors)
            ? e.event_instructors.map(
                (ei: any) => new EventInstructor(ei)
            )
            : [];

        return new Event({
            venue,
            date: e.date ?? null,
            event_artists,
            event_instructors,
            id: e.id ?? null,
            documentId: e.documentId ?? null,
            title: e.title ?? null,
            ticketUrl: e.ticketUrl ?? null,
            instagramUrl: e.instagramUrl ?? null,
            createdAt: e.createdAt ?? null,
            updatedAt: e.updatedAt ?? null,
            publishedAt: e.publishedAt ?? null,
            source: e.source ?? null,
            lastSeen: e.lastSeen ?? null
        });
    }
}



export { Event, EventInterface };